import React, { memo, useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import cx from 'clsx';
import { IconRcCupV2 } from '@/assets/overview';
import { useUserInfo } from 'hooks';

import style from './index.module.css';

type RankingTagProps = {
  address?: string;
  className?: string;
  enableRankingLink?: boolean;
};

export const RankingTagSimple = memo(
  ({ address, className, enableRankingLink }: RankingTagProps) => {
    const { data, isLoading } = useUserInfo(address);
    const text = isLoading ? '-' : data?.rank_at;

    const Tag = useMemo(
      () => (
        <>
          <IconRcCupV2 className={style.rankingIcon} />
          {text}
        </>
      ),
      [text],
    );

    return !data?.rank_at ? null : enableRankingLink ? (
      <NavLink to="/ranking" className={cx(style.rankingTag, className)}>
        {Tag}
      </NavLink>
    ) : (
      <div className={cx(style.rankingTag, className)}>{Tag}</div>
    );
  },
);

export const RankingTag = (
  props: RankingTagProps & {
    disableRankPop?: boolean;
  },
) => {
  return <RankingTagSimple {...props} />;
};

export default RankingTag;
